import { styled } from '@mui/material/styles';
import { Box, Grid, Typography, Select, Pagination } from '@mui/material';

export const LibraryContainer = styled(Box)({
  margin: '1% auto',
  padding: '1%',
  marginTop: '84px',
  backgroundColor: 'white',
  borderRadius: '5px',
  maxWidth: '1265.01px',
});

export const HeaderGrid = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
});

export const TitleTypography = styled(Typography)({
  fontFamily: "'Montserrat',sans-serif",
  fontSize: '39.81px',
  fontWeight: 700,
  lineHeight: '48.53px',
});

export const ControlGrid = styled(Grid)({
  marginTop: '10px',
  height: '50.84px',
  display: 'flex',
  border: '0.91px solid #E5E5E5',
  borderRadius: '5px',
});

export const SelectTypography = styled(Typography)({
  fontFamily: "'Montserrat',sans-serif",
  fontWeight: 600,
  fontSize: '11.8px',
  lineHeight: '17.7px',
  marginRight: '8px',
  marginTop: '3px',
  whiteSpace: 'nowrap',
});

export const StyledSelect = styled(Select)({
  height: '26px',
});

export const ScenarioNoGrid = styled(Grid)({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const ScenarioNumberLabel = styled(Typography)({
  fontWeight: 600,
  fontSize: '11.8px',
  marginRight: '8px',
});

export const CardsContainer = styled(Grid)({
  maxHeight: 'calc(100vh - 200px)',
  overflowY: 'auto',
  paddingBottom: '70px',
});

export const FixedPagination = styled(Pagination)({
  position: 'fixed',
  bottom: '20px',
  left: '50%',
  transform: 'translateX(-50%)',
});

export const CalendarComponent = styled(Grid)({});

export const SearchForm = styled(Grid)({
  display: 'flex',
  marginTop: '13px',
});

export const CustomDatePickerWrapper = styled('div')`
  .react-datepicker__day--selected,
  .react-datepicker__day--in-selecting-range,
  .react-datepicker__day--in-range {
    background-color: red !important; /* Set selected background color to red */
    color: white !important; /* Optional: makes text readable on red */
  }

  .react-datepicker__day--keyboard-selected {
    background-color: red !important;
    color: white !important;
  }
`;

export const DatePickerContainer = styled('div')({
  display: 'flex',
  padding: '10px',
});

export const StyledDialogHeader = styled(Grid)({
  display: 'flex',
  justifyContent: 'space-between',
});

export const StyledTitle = styled(Typography)({
  fontSize: '24px',
  fontWeight: 600,
  lineHeight: '29.26px',
  color: '#565759',
});

export const StyledExitButton = styled(Grid)({
  width: '34px',
  height: '34px',
  borderRadius: '50%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
  background: 'rgba(157, 157, 157, 0.04)',
});

export const StyledUserContainer = styled(Grid)({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '20px',
  marginTop: '15px',
  justifyContent: 'center',
  alignContent: 'start',
  alignItems: 'start',
});

export const StyledUserCard = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '72px',
  alignContent: 'center',
  cursor: 'pointer',
  maxWidth: '100%',
  minWidth: '72px',
});

export const StyledUserImageWrapper = styled(Grid)<{ isSelected: boolean }>(({ isSelected }) => ({
  width: '72px',
  height: '72px',
  borderRadius: '50%',
  border: isSelected ? '1px solid red' : '1px solid rgba(157, 157, 157, 0.08)',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}));

export const StyledUserName = styled(Typography)({
  fontSize: '12px',
  fontWeight: 400,
  lineHeight: '15px',
  color: '#3d5a80',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%',
  textAlign: 'center',
  '&:hover': {
    cursor: 'pointer',
  },
});

export const StyledLinkContainer = styled(Grid)({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '20px',
});

export const StyledLinkText = styled(Typography)({
  fontSize: '12px',
  fontWeight: 600,
  lineHeight: '15px',
  color: '#404040',
});

export const StyledLinkBox = styled(Grid)({
  background: 'rgba(157, 157, 157, 0.04)',
  display: 'flex',
  width: '512px',
  height: '53px',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 10px',
  borderRadius: '16px',
  marginTop: '15px',
});

export const StyledLinkUrl = styled(Typography)({
  fontSize: '13px',
  fontWeight: 500,
  lineHeight: '17.5px',
  color: 'rgba(61, 90, 128, 0.5)',
});

export const StyledCopyIcon = styled('img')({
  width: '24px',
  height: '24px',
  cursor: 'pointer',
});
